import service from '@/utils/request'

// 列表
export function actMatchList(data) {
    return service({
        url: '/service/admin/actMatchList',
        method: 'get',
        params: data
    })
}

// 详情
export function actMatchElem(data) {
    return service({
        url: '/service/admin/actMatchElem',
        method: 'get',
        params: data
    })
}

// 新增
export function actMatchAdd(data) {
    return service({
        url: '/service/admin/actMatchAdd',
        method: 'post',
        data
    })
}

// 编辑
export function actMatchEdit(data) {
    return service({
        url: '/service/admin/actMatchEdit',
        method: 'post',
        data
    })
}

// 删除
export function actMatchDelete(data) {
    return service({
        url: '/service/admin/actMatchDelete',
        method: 'post',
        data
    })
}
